import { render, staticRenderFns } from "./applications.vue?vue&type=template&id=bb25470c&scoped=true"
import script from "./applications.vue?vue&type=script&lang=js"
export * from "./applications.vue?vue&type=script&lang=js"
import style0 from "./applications.vue?vue&type=style&index=0&id=bb25470c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb25470c",
  null
  
)

export default component.exports